import { initializeApp } from "firebase/app";
import { getFirestore, collection, getDocs } from "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: "falhari-fruitfulhabit.firebaseapp.com",
  projectId: "falhari-fruitfulhabit",
  storageBucket: "falhari-fruitfulhabit.appspot.com",
  messagingSenderId: "806872696515",
  appId: "1:806872696515:web:2b11c5d23b72b7029c0476",
  measurementId: "G-7BZQD7FCQ9"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export {
  app,
  db,
  collection,
  getDocs
};
